import { useTranslation } from "react-i18next";

export const AddonServiceDetailsTable = (props) => {
  const { t } = useTranslation();
  const { booking, branding } = props;

  const addonServiceDetailsTable =
    booking.addonServices.length > 0 ? (
      <div className="wrapper">
        <table className="table-wrapper">
          <thead>
            <tr
              style={{
                backgroundColor: branding.headingColor,
                color: "#fff",
                fontFamily: branding.headingFont,
              }}
            >
              <th className="padding-10">
                {t("booking.add_on_service.service_name")}
              </th>
              <th className="padding-10">
                {t("booking.add_on_service.description")}
              </th>
              <th className="padding-10">
                {t("booking.add_on_service.service_price")}
              </th>
            </tr>
          </thead>
          <tbody>
            {booking.addonServices.map((service, index) => (
              <tr key={index}>
                <td className="addon-service-details">{service.serviceName}</td>
                <td className="addon-service-details">
                  {service.serviceDescription || "N/A"}
                </td>
                <td
                  className="addon-service-details"
                  style={{
                    color: branding.priceTagColor,
                    fontWeight: "bold",
                  }}
                >
                  {service.servicePrice.toLocaleString()} VND
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p style={{ marginTop: "20px" }}>
        {t("booking.add_on_service.not_added")}
      </p>
    );
  return <div>{addonServiceDetailsTable}</div>;
};
